<div class="container flex flex-col justify-start items-start">
  <h3>
    {{
      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.ACTIVE_ERROR_INFORMATION.HOW_TO_REPAIR' | translate
    }}
  </h3>
  <ng-container *ngFor="let cause of causes">
    <ng-container *ngIf="cause?.measure">
      <div
        class="actions"
        [innerHTML]="cause.measure | gtsHTMLTags | domSanitizer: SecurityContext.HTML"
      ></div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="authStore.isMaintainerOrUser$ | async">
    <ng-container *ngIf="authStore.getVkorg() | async as vkorg">
      <ng-container *ngIf="boilerSerial && !(authStore.isDemo$ | async)">
        <mat-divider></mat-divider>
        <a
          data-at-spare-app
          mat-raised-button
          color="primary"
          [href]="viessmannShopUrl"
          target="_blank"
          gtm="onGoToPage"
          gtmAction="Viessmann shop"
          gtmCategory="statusPanel"
          [gtmLabel]="viessmannShopUrl"
          class="mat-raised-button mat-primary"
        >
          {{ '+INSTALLATIONS.INSTALLATION.ERROR_LIST.VIESSMANN_SHOP.TITLE' | translate }}
        </a>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
